import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Pie de pagina institucional de EVOLTI, en las pantallas con sesion.
 *
 * El layout compartido no tiene pie de pagina, asi que va aqui, debajo del
 * layout, sin tocar la libreria. Los textos y enlaces salen del pie de
 * evolti.co (copyright, politica de datos y terminos de uso). La posicion
 * respecto al menu lateral la pone `evolti-shell.css`.
 */
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="evolti-footer">
      <p>© {{ year }} Evolti. {{ 'footer.rights' | translate }}</p>
      <nav [attr.aria-label]="'footer.legal' | translate">
        <a [href]="privacyUrl" target="_blank" rel="noopener noreferrer">
          {{ 'footer.privacy' | translate }}
        </a>
        <a [href]="termsUrl" target="_blank" rel="noopener noreferrer">
          {{ 'footer.terms' | translate }}
        </a>
      </nav>
    </footer>
  `,
})
export class AppFooterComponent {
  readonly year = new Date().getFullYear();
  readonly privacyUrl =
    'https://evolti.co/wp-content/uploads/2025/08/POLITICA-DE-DATOS-EVOLTI-COMPANY-SAS-BIC.pdf';
  readonly termsUrl = 'https://evolti.co/terminos-y-condiciones-de-uso-plataforma/';
}
